import { action, observable } from "mobx";
import GuestPayment from "~/models/GuestPayment";
import GuestPaymentRepository from "~/repository/GuestPaymentRepository";
import NestStore from "~/stores/NestStore";

class GuestPaymentStore extends NestStore {
  /**
   * @property {number|null}
   */
  guestPaymentId = null;

  /**
   * @property {GuestPayment}
   */
  @observable guestPayment;

  /**
   * @property {object}
   */
  @observable stripeApiKeys;

  /**
   * @property {string}
   */
  @observable stripeToken;

  /**
   * @property {string|null}
   */
  token = null;

  /**
   * @property {string}
   */
  @observable cardholderName = "";

  rootStore = null;

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.guestPayment = new GuestPayment();
    this.guestPaymentRepository = new GuestPaymentRepository();
  }

  set tourId(tourId) {
    this.guestPayment.setData({ tourId });
  }

  set otherProductId(otherProductId) {
    this.guestPayment.setData({ otherProductId });
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getGuestPayment()]).then(() => {
      this.isLoading = false;
    });
  }

  @action
  getGuestPayment() {
    let query = null;

    if (this.token) {
      query = { token: this.token };
    }

    return this.guestPaymentRepository.getOne(this.guestPaymentId, query).then(response => {
      this.guestPayment = new GuestPayment(response.data.guestPayment);
    });
  }

  @action
  create() {
    this.isLoading = true;
    this.clearErrorMessages();

    const { guestStore } = this.rootStore;
    const { guest } = guestStore;

    return this.guestPaymentRepository
      .create({
        tourId: this.guestPayment.tourId,
        otherProductId: this.guestPayment.otherProductId,
        token: this.stripeToken,
        cardholderName: this.cardholderName,
        guest: {
          email: guest.email,
          address: {
            street: guest.address.street,
            street2: guest.address.street2,
            city: guest.address.city,
            state: guest.address.state,
            zip: guest.address.zip,
            country: guest.address.country,
          },
          firstName: guest.firstName,
          lastName: guest.lastName,
          contactPhone: guest.contactPhone,
        },
      })
      .then(response => {
        this.guestPayment.setData({ guestPaymentId: response.data.guestPayment.guestPaymentId });

        return response;
      })
      .catch(error => {
        this.setErrorMessages(error);

        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

export default GuestPaymentStore;
